
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class RacingGroupT3Form extends Vue {
  @Prop()
  form!: any

  @Prop()
  formFields!: any
}
